export default __webpack_public_path__ + "static/media/logo.b3a1c539.svg";